/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S8_I4Inputs */

const tr_kullanim_s8_i4 = /** @type {(inputs: Kullanim_S8_I4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloudflare WAF ve DDoS koruması aktiftir.`)
};

const en_kullanim_s8_i4 = /** @type {(inputs: Kullanim_S8_I4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloudflare WAF and DDoS protection are active.`)
};

const de_kullanim_s8_i4 = /** @type {(inputs: Kullanim_S8_I4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloudflare WAF und DDoS-Schutz sind aktiv.`)
};

const ru_kullanim_s8_i4 = /** @type {(inputs: Kullanim_S8_I4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Активны Cloudflare WAF и защита от DDoS.`)
};

/**
* | output |
* | --- |
* | "Cloudflare WAF and DDoS protection are active." |
*
* @param {Kullanim_S8_I4Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s8_i4 = /** @type {((inputs?: Kullanim_S8_I4Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S8_I4Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s8_i4(inputs)
	if (locale === "de") return de_kullanim_s8_i4(inputs)
	if (locale === "ru") return ru_kullanim_s8_i4(inputs)
	return tr_kullanim_s8_i4(inputs)
});